import styled from "styled-components";
import { checkedInColors } from "src/components/CheckedIn/CheckedInStyles";

export const Hero = styled.section<{ $home: boolean }>`
    position: relative;
    width: 100%;
    height: clamp(200px, 55vw, 330px);
    background: var(--checked-in-primary);
    color: ${p => p.$home ? checkedInColors.white : checkedInColors.black};
    overflow: hidden;
    img, video { display: block; width: 100%; height: 100%; object-fit: cover; }
    &::after {
        content: "";
        position: absolute;
        inset: 45% 0 0;
        background: linear-gradient(transparent, #0009);
        pointer-events: none;
    }
    h1 { position: absolute; bottom: 22px; left: 20px; right: 20px; z-index: 1;
        margin: 0; font-size: clamp(28px, 6vw, 42px); font-weight: 600; overflow-wrap: anywhere; }
    > button { position: absolute; z-index: 2; top: 20px; left: 16px; }
`;

export { SearchBox } from "src/components/CheckedIn/CheckedInContentStyles";

export const DirectoryGrid = styled.div<{ $categories?: boolean }>`
    display: grid;
    grid-template-columns: ${p => p.$categories ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))"};
    gap: 12px;
    @media (min-width: 760px) { grid-template-columns: repeat(3, minmax(0, 1fr)); }
`;

export const DirectoryTile = styled.button<{ $category?: boolean }>`
    background: #fff;
    color: ${checkedInColors.black};
    min-width: 0;
    min-height: ${p => p.$category ? "88px" : "84px"};
    padding: ${p => p.$category ? "12px 22px" : "18px 10px"};
    border: 1px solid #e8e8e8;
    border-radius: 24px;
    box-shadow: 0 3px 4px #0003;
    display: flex;
    align-items: center;
    justify-content: ${p => p.$category ? "space-between" : "center"};
    gap: 8px;
    font-size: ${p => p.$category ? "23px" : "16px"};
    font-weight: 600;
    overflow-wrap: anywhere;
    cursor: pointer;
    text-align: ${p => p.$category ? "left" : "center"};
    img { width: 62px; height: 62px; flex-shrink: 0; border-radius: 50%; object-fit: cover; }
    svg { flex-shrink: 0; }
    &:hover { border-color: ${checkedInColors.black}; }
`;

export const SectionHeading = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #e5e5e5;
    h2 { font-size: 22px; font-weight: 600; margin: 4px 0 0; overflow-wrap: anywhere; }
    p { margin: 0; font-size: 14px; }
    button { flex-shrink: 0; }
`;

export const PostAsset = styled.div<{ $detail: boolean }>`
    position: relative;
    min-height: ${p => p.$detail ? "64px" : "0"};
    > button { position: absolute; z-index: 2; top: 20px; left: 16px; }
`;

export const PostTextButton = styled.button`
    font: inherit;
    text-align: left;
    color: inherit;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
    font-weight: 600;
`;

export {
    ViewerRoot, ViewerBar, ViewerSection, PostCollection, PostCard, PostMedia, PostContent, ViewerMessage
} from "src/components/CheckedIn/CheckedInContentStyles";
